import { Injectable } from '@angular/core';
import { ScreenRightsModel } from '../models/screen-rights-model'
import { GeneralSettingsModel } from '../models/general-settings'
import { CurrentUserModel } from '../models/current-user'
import { BaseSettingsModel } from '../models/base-settings.model'
const maxComments: number = 25;

const TOKEN_KEY = 'AuthToken';
const SIGNALR_MESSAGES = 'SIGNALRMESSAGES';
const PROFILE_PICTURE = 'Profile_Picture_User';
const RIGHTS_KEY = 'Rights';
const GEN_SET_KEY = 'GeneralSettings';
const BASE_URL_KEY = 'baseUrl';
const IDENTITY_URL_KEY = 'identityUrl';
const IDENTITY_APP_URL_KEY = 'identityAppUrl';
const SIGNALR_URL_KEY = 'signalrUrl';
const REFRESH_TOKEN_KEY = 'refreshToken';
const CURRENT_USER_KEY = 'currentUser';
const AUDIT_REASON_ID = 'audit-reason-id';
const AUDIT_REASON_OTH = 'audit-reason-oth';

@Injectable({
  providedIn: 'root'
})
export class StorageService {


  constructor() { }

  private removeItem(key: string) {
    window.sessionStorage.removeItem(key);
  }
  private AppendItemChangeItem(value: string) {
    var obj = window.sessionStorage.getItem(SIGNALR_MESSAGES);
    var values = [];
    if (obj != null) {
      values = JSON.parse(obj);
    }
    if (values.find((test) => test === value) === undefined) {
      values.push(value);
    }

    if (values.length > maxComments) {
      values.pop();
    }
    window.sessionStorage.setItem(SIGNALR_MESSAGES, JSON.stringify(values));
  }
  private GetItemChange() {
    var obj = window.sessionStorage.getItem(SIGNALR_MESSAGES);
    return obj;
  }

  private setItem(key: string, value: string) {
    this.removeItem(key);
    window.sessionStorage.setItem(key, value);
  }
  
  savePublicToken(key: string, res: any) {
    const expiryTime = 5000 * 60 * 1000; // 5000 minutes in milliseconds
    const data = {
      value: res,
      expiry: Date.now() + expiryTime,
    };

    sessionStorage.setItem(key, JSON.stringify(data));
    // window.sessionStorage.setItem(key, access_Token);
  }

  getPublicStoredToken(key: string): any | null {
    const storedData = sessionStorage.getItem(key);
    if (!storedData) return null;

    const data = JSON.parse(storedData);

    if (Date.now() > data.expiry) {
      sessionStorage.removeItem(key); // Remove expired token
      return null;
    }

    return data.value;
  }
  clearPublicToken(key: string) {
    localStorage.removeItem(key); // Remove expired token
  }

  private getItem(key: string) {
    return window.sessionStorage.getItem(key);
  }
  public setSignalRMessage(value: string) {
    this.AppendItemChangeItem(value);
  }
  public getSignalRMessage(): string {
    return this.GetItemChange();
  }
  public clearSignalRMessage() {
    //this.removeItem(SIGNALR_MESSAGES);
  }
  public setToken(token: string) {
    if (!token) return;
    this.setItem(TOKEN_KEY, token);
  }

  public setProfilePicture(profilePicture: string) {
    if (!profilePicture) return;
    this.setItem(PROFILE_PICTURE, profilePicture);
  }
  private setRefreshToken(token: string) {
    if (!token) return;
    this.setItem(REFRESH_TOKEN_KEY, token);
  }

  private setRights(rights: ScreenRightsModel[]) {
    if (!rights) return;
    this.setItem(RIGHTS_KEY, JSON.stringify(rights));
  }

  private setGeneralSettings(settings: GeneralSettingsModel) {
    if (!settings) return;
    this.setItem(GEN_SET_KEY, JSON.stringify(settings));
  }

  private setBaseUrl(url: string) {
    this.setItem(BASE_URL_KEY, url);
  }

  private setIdentityUrl(url: string) {
    this.setItem(IDENTITY_URL_KEY, url);
  }

  private setIdentityAppUrl(url: string) {
    this.setItem(IDENTITY_APP_URL_KEY, url);
  }

  private setSignalRUrl(url: string) {
    this.setItem(SIGNALR_URL_KEY, url);
  }

   updateCurrentUser(currentUser: CurrentUserModel) {
    if (!currentUser) return;
    this.setItem(CURRENT_USER_KEY, JSON.stringify(currentUser));
    this.setItem(CURRENT_USER_KEY + "-" + currentUser.userId, JSON.stringify(currentUser));
  }
  private setCurrentUser(currentUser: CurrentUserModel) {
    if (!currentUser) return;
    this.setItem(CURRENT_USER_KEY, JSON.stringify(currentUser));
    this.setItem(CURRENT_USER_KEY + "-" + currentUser.userId, JSON.stringify(currentUser));
  }
  setUserData(data: CurrentUserModel) {
    this.setToken(data.token);
    this.setRefreshToken(data.refreshToken);
    this.setRights(data.rights);
    // this.setProfilePicture(data.userPicUrl);
    this.setGeneralSettings(data.generalSettings);
    delete data.token;
    delete data.refreshToken;
    delete data.rights;
    delete data.generalSettings;

    this.setCurrentUser(data);
  }

  setBaseSettings(settings: BaseSettingsModel) {
    this.setBaseUrl(settings.baseUrl);
    this.setIdentityUrl(settings.identityUrl);
    this.setIdentityAppUrl(settings.identityAppUrl);
    this.setSignalRUrl(settings.signalrUrl);
  }

  get BaseUrl(): string {
    const item = this.getItem(BASE_URL_KEY);
    return item;
  }

  get IdentityUrl(): string {
    const item = this.getItem(IDENTITY_URL_KEY);
    return item;
  }

  get IdentityAppUrl(): string {
    const item = this.getItem(IDENTITY_APP_URL_KEY);
    return item;
  }

  get SignalRUrl(): string {
    const item = this.getItem(SIGNALR_URL_KEY);
    return item;
  }

  get Token(): string {
    const item = this.getItem(TOKEN_KEY);

    return item;
  }

  get RefreshToken(): string {
    const item = this.getItem(REFRESH_TOKEN_KEY);
    return item;
  }

  get HasToken(): boolean {
    return this.Token ? true : false;
  }

  get AuthHeader(): string {
    const token = this.Token;
    return token ? 'Bearer ' + token : '';
  }

  get Rights(): ScreenRightsModel[] {
    const stringValue = this.getItem(RIGHTS_KEY);
    const data = JSON.parse(stringValue) as ScreenRightsModel[];
    return data;
  }

  get GeneralSettings(): GeneralSettingsModel {
    const stringValue = this.getItem(GEN_SET_KEY);
    const data = JSON.parse(stringValue) as GeneralSettingsModel;
    return data;
  }

  get CurrentUser(): CurrentUserModel {
    const stringValue = this.getItem(CURRENT_USER_KEY);
    const data = JSON.parse(stringValue) as CurrentUserModel;
    return data;
  }

  get GetAuditReasonId(): string {
    const stringValue = this.getItem(AUDIT_REASON_ID);
    const data = stringValue as string;
    return data;
  }

  get GetAuditReasonOth(): string {
    const stringValue = this.getItem(AUDIT_REASON_OTH);
    const data = stringValue as string;
    return data;
  }

  clear() {
    localStorage.setItem("selectedRfqSupplierId", null);
    localStorage.setItem("selectedRFQData", null);
    localStorage.setItem("selectedRFQId", null);
    localStorage.setItem('selectedRfqsList', null);
    this.removeItem(TOKEN_KEY);
    this.removeItem(RIGHTS_KEY);
    this.removeItem(GEN_SET_KEY);
    this.removeItem(REFRESH_TOKEN_KEY);
    this.removeItem(CURRENT_USER_KEY);
    this.removeItem(AUDIT_REASON_ID);
    this.removeItem(AUDIT_REASON_OTH);
  }
}
